<template>
<div v-if="homeLoan" ref="mainDiagram" @mousemove="drag($event)"  @mouseup="endDrag($event)">
    <div class="xxxray" v-for="(group, groupIndex) in homeLoan.groups" :key="groupIndex" style="padding:2px;margin-bottom:5px;overflow-x:scroll">
        <div style="color:#aaa;font-size:12px;padding:2px">
            {{groupTitle(groupIndex)}}: {{totalLoans(group) | currency}} total.
        </div>

        <!-- Loans -->
        <div style="display:flex;position:relative">
            <div class="loan no-select" @mousedown="startLoanDrag($event, loan)" @dblclick="editLoan(loan)" v-for="(loan, loanIndex) in group.loans" :class="{dragging: loan._dragStart && loan._dragMode != 'splitter'}" style="display:flex" :style="loanStyle(loan, group)" :key="'loan' + loanIndex">
    
                <div style="flex-grow:1;padding:4px 6px;border:solid 3px rgba(0,0,0,0.1);margin:2px;border-radius:5px;color:white;font-weight:500" :style="loanBarStyle(loan)" >
                    <div style="float:right;margin-top:-4px">
                        <v-menu offset-y left>
                            <template v-slot:activator="{ on }">
                                <v-icon color="white" small v-on="on">keyboard_arrow_down</v-icon>
                            </template>
                            <v-list>
                                <v-list-item @click="editLoan(loan)">
                                    <v-list-item-title>Edit Loan</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="addLoan(loan)">
                                    <v-list-item-title>Add Loan</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="split(loan)">
                                    <v-list-item-title>Split Loan</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="split(loan, true)">
                                    <v-list-item-title>Duplicate Loan</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="group.loans.length > 1" @click="deleteLoan(loan)">
                                    <v-list-item-title>Delete Loan</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>  
                    </div>

                    {{loanTitle(loan)}} <span style="color:white;font-weight:300;xfont-size:14px" v-if="loan.rate">@ <EditableText v-model="loan.rate" dark/>%</span>
                    <div style="white-space:nowrap;display:inline-block;line-height:16px;xfont-size:14px;font-weight:300"> 
                        <LabelMenu v-model="loan.investment" underline="white" :menus="loanPurposeOptions" />
                        <LabelMenu v-model="loan.fixed" underline="white" :menus="fixedOptions" />
                        <LabelMenu v-if="loan.fixed"  v-model="loan.rateLock" underline="white" :menus="rateLockOptions" />
                        <LabelMenu v-model="loan.io" underline="white" :menus="ioOptions" />
                    </div>
                </div>
                <div color="grey" @mousedown="$set(loan, '_dragMode', 'splitter')"  class="loan-handle mt-1" :class="{dragging: loan._dragStart && loan._dragMode == 'splitter'}" :key="'loanHandle' + loanIndex">
 
                </div>
            </div>
            <div style="padding:8px 2px 8px 5px; width:70px;">
                {{getLVR(group)}}%
            </div>
       
        </div>

        <!-- Properties -->
        <div style="display:flex;width:100%">
            <div @mousedown="startPropertyDrag($event, property)" @dblclick="editProperty(property)" v-for="(property, propertyIndex) in group.properties" style="color:white;display:flex;border:solid 3px rgba(0,0,0,0.1);margin:2px;border-radius:5px;flex-grow:1" class="property no-select" :class="{dragging: Boolean(property._dragStart)}" :style="propertyStyle(property, group)" :key="'property' + propertyIndex">
                <div style="padding:4px 6px;font-weight:500;flex-grow:1">

                    <div style="float:right;margin-top:-4px">
                        <v-menu offset-y left>
                            <template v-slot:activator="{ on }">
                                <v-icon color="white" small v-on="on">keyboard_arrow_down</v-icon>
                            </template>
                            <v-list>
                                <v-list-item @click="addProperty(property)">
                                    <v-list-item-title>Add Property</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="group.properties.length > 1" @click="deleteProperty(property)">
                                    <v-list-item-title>Delete Property</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>  
                    </div>

                    {{property.value | thousands}}
                    <span style="font-weight:300;xfont-size:14px">
                        <LabelMenu v-model="property.existing" underline="white" :menus="existingPropertyOptions"/>
                        <LabelMenu v-model="property.investment" underline="white" :menus="investmentPropertyOptions"/>
                        <LabelMenu v-model="property.type" underline="white" :menus="propertyTypes"/>
                    </span>
                    <span style="font-weight:300;">{{property.address}}</span>
                </div>
            </div>
        </div>
    </div>  <!--  End Groups -->

    <div class="bottom-links">
 
        <a class="bottom-link" @click="addGroup">Add Group</a> |
        <v-menu offset-y left>
            <template v-slot:activator="{ on }">
                <a v-on="on" class="bottom-link" @click>Delete Group</a>
            </template>
            <v-list>
                <v-list-item v-for="(group, groupIndex) in homeLoan.groups" @click="deleteGroup(groupIndex)" :key="'dg' + groupIndex">
                    <v-list-item-title>{{groupTitle(groupIndex)}}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> |
        <a class="bottom-link" @click="copy">Copy</a> | 
        <a class="bottom-link" @click="$set(homeLoan, 'summaryVisible', !homeLoan.summaryVisible)">{{homeLoan.summaryVisible ? 'Hide Summary' : 'Summary'}}</a> |
        <a class="bottom-link" @click="$set(homeLoan, 'locked', !homeLoan.locked)">{{homeLoan.locked ? 'Unlock' : 'Lock'}}</a> |
        <a class="bottom-link" @click="help">Help</a>

        <!-- I've currently hidden the save timer to see if its better not showing -->
        <span style="visibility:hidden"><Timer :seconds="9" :watch="homeLoan" @run="saveDiagram" /></span>

    </div>

    <!-- Summary  -->
    
    <div v-if="homeLoan.summaryVisible" class="summary">
         <!-- :class="{hidden: !homeLoan.summaryVisible}"> -->
        <div v-for="attribute in shortSummary" :title="attribute.name" :key="attribute.name">
            {{attribute.title}}: {{attribute.value}}
        </div>
    </div>
     

    <!-- Simple Version -->
    <div ref="simple" class="simple-version-div" style="font-size:16px;max-width:800px;">
        <template v-for="(group, groupIndex) in homeLoan.groups" >
        <div style="color:#888;font-size:14px;padding:2px;" :key="'gh' + groupIndex">{{groupTitle(groupIndex)}}: {{totalLoans(group) | currency}} total.</div>
        <table cellspacing="5"  width="100%" :key="'sgl' + groupIndex">
            <tr>
                <td v-for="(loan, loanIndex) in group.loans" :key="'sl' + loanIndex" :width="percentage(loan, group) + '%'" :style="loanBarStyle(loan, group)" style="color:white;border-radius:5px;padding:5px;min-width: 150px" valign="top">
                    <strong>{{loanTitle(loan)}}</strong> {{loanDetails(loan)}}
                </td>
                <td style="padding:5px;">
                    {{getLVR(group)}}%
                </td>
            </tr>
        </table>
        <table cellspacing="5"  width="100%" :key="'sgp' + groupIndex" style="margin-top:-5px">
            <tr>
                <td v-for="(property, propertyIndex) in group.properties" :key="'sp' + propertyIndex" style="color:white;border-radius:5px;padding:5px;min-width:150px;" :style="propertyColour(property, group) + 'width:' + percentage(property, group) + '%'" valign="top">
                    <strong>{{property.value | currency}}</strong> {{propertyDetails(property)}}
                </td>
            </tr>
        </table>
        </template>
    </div>

    <!-- Loan Dialog -->

    <DialogBox title="Loan Details" :settings="loanDialog.settings" save-on-enter @save="saveLoan(loanDialog.loan)">
        <div class="pa-4">
            <div class="blue--text text--darken-2" style="margin-top:-15px" :style="{'visibility': activeLoanPayment ? 'visible' : 'hidden'}">
                <span v-if="loanDialog.loan.io">IO </span>
                Repayment {{activeLoanPayment | currency}}pm
                 | {{activeLoanPayment * 12 / 52 | currency}}pw

            </div>
            <div style="display:flex">
                <!-- <v-text-field ref="focus" v-model.number.lazy="loanDialog.loan.amount" label="Base Amount" style="margin-right:10px" /> -->
                <currency-box ref="focus" v-model.number.lazy="loanDialog.loan.amount" label="Base Amount" style="margin-right:10px" />
                <v-select v-bind:items="lmiOptions" v-model="loanDialog.loan.lmiType" label="LMI" style="margin-right:10px" ></v-select>
                <currency-box v-model.number="loanDialog.loan.lmi" label="Est LMI" />
            </div>

            <div style="display:flex">
                <v-text-field v-model.number="loanDialog.loan.rate" label="Rate %" style="margin-right:10px"/>
                <v-select v-bind:items="yearsOptions" v-model="loanDialog.loan.years" label="Years" style="margin-right:10px" ></v-select>
                <currency-box v-model="loanDialog.loan.newMoney" label="New Money (if different)" />
            </div>
            <div style="display:flex;flex-wrap:wrap;gap:15px" class="mb-2">
                <v-checkbox v-model="loanDialog.loan.package" label="Package" hide-details />
                <v-checkbox v-model="loanDialog.loan.special" label="Special" hide-details />
                <v-checkbox v-model="loanDialog.loan.investment" label="Investment" hide-details/>
                <v-checkbox v-model="loanDialog.loan.existing" label="Existing Debt Keeping" hide-details />
            </div>

            <div style="display:flex">
                <v-select v-bind:items="fixedOptions" v-model.number="loanDialog.loan.fixed" :label="(loanDialog.loan.fixed ? 'Fixed Period' : 'Fixed or Variable')" style="margin-right:10px" ></v-select>
                <div v-if="loanDialog.loan.fixed" style="flex-basis:180px">
                    <v-switch v-model="loanDialog.loan.rateLock" label="Rate Lock"/>
                </div>
                <v-select v-bind:items="ioOptions" v-model.number="loanDialog.loan.io" :label="(loanDialog.loan.io ? 'Interest Only Period' : 'P&I or IO')" ></v-select>
            </div>
            <div>
                <v-text-field v-model="loanDialog.loan.product" label="Product" hint="Include any offers or rebates"/>
            </div>
        </div>  
        <DeleteButton slot="footer" @delete="deleteLoan(loanDialog.loan._originalLoan); loanDialog.settings.visible = false;" style="float:left"></DeleteButton>

    </DialogBox>  

    <!-- Property Dialog -->

    <DialogBox title="Propety Details" :settings="propertyDialog.settings" save-on-enter @save="saveProperty(propertyDialog.property)">
        <div class="pa-4">
            <currency-box ref="focus" v-model.number="propertyDialog.property.value" label="Value" />
            <div style="display:flex">
                <v-checkbox v-model="propertyDialog.property.investment" label="Investment" />
                <v-checkbox style="margin-left:10px" v-model="propertyDialog.property.existing" label="Existing" />
            </div>
            <v-text-field v-model="propertyDialog.property.address" label="Address" />
            <v-select v-bind:items="propertyTypes" v-model="propertyDialog.property.type" label="Type" ></v-select>
        </div>  
        <DeleteButton v-if="!homeLoan.locked" slot="footer" @delete="deleteProperty(propertyDialog.property._originalProperty);propertyDialog.settings.visible = false;" style="float:left"></DeleteButton>

    </DialogBox>      
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import LabelMenu from '../ui-elements/LabelMenu'
import AlertHelpers from '../helpers/AlertHelpers'
import LoanSecurityHelpers from '../helpers/LoanSecurityHelpers'
import DialogBox from '../ui-elements/DialogBox'
import CurrencyBox from '../ui-elements/CurrencyBox'
import DeleteButton from '../ui-elements/DeleteButton'
import StringHelpers from '../helpers/StringHelpers'
import Utilities from '../helpers/Utilities'
import clipboard from 'clipboard-js'
import NumberHelpers from '../helpers/NumberHelpers'
import Timer from '../ui-elements/Timer'
import EditableText from '../ui-elements/EditableText'


export default {
    data() {
        return {
            dragging: false,
            loanDialog: {
                loan: {
                    amount: 0,
                    years: 30,
                },
                settings: {
                    visible: false,
                    title: 'Loan Details'
                }
            },
            propertyDialog: {
                property: {
                    value: 0,
                },
                settings: {
                    visible: false,
                    title: 'Property Details'
                }
            },
            fixedOptions: [
                {text: 'Variable', value: 0},
                {text: '1y Fixed', value: 1},
                {text: '2y Fixed', value: 2},
                {text: '3y Fixed', value: 3},
                {text: '4y Fixed', value: 4},
                {text: '5y Fixed', value: 5},
            ],
            rateLockOptions: [
                {text: 'No lock', value: false},
                {text: 'Rate Lock', value: true},
            ],
            ioOptions: [
                {text: 'P&I', value: 0},
                {text: '1y IO', value: 1},
                {text: '2y IO', value: 2},
                {text: '3y IO', value: 3},
                {text: '4y IO', value: 4},
                {text: '5y IO', value: 5},
            ],
            investmentPropertyOptions: [
                {text: 'Owner Occ', value: false},
                {text: 'Investment', value: true},
            ],            
            existingPropertyOptions: [
                {text: 'New', value: false},
                {text: 'Existing', value: true},
            ],

            loanPurposeOptions: [
                {text: 'OO', value: false},
                {text: 'Inv', value: true},
            ],   
            
            lmiOptions: ['None', 'Capitalised', 'Included'],

            propertyTypes: [ 
                {text: 'House', value: "House"},
                {text: "Townhouse", value: "Townhouse"},
                {text: 'Unit', value: "Unit"},
                {text: 'Land', value: "Land"}, 
                {text: 'Build', value: "Build"} 
            ],
        }
    },

    components: {
        LabelMenu, DeleteButton, CurrencyBox,
        DialogBox, Timer, EditableText,
    },
    
    props: {
        homeLoan: Object,
    },

    computed: {

        activeLoanPayment() {
            const payment = LoanSecurityHelpers.loanPayment(this.loanDialog.loan)
            return payment
        },
        yearsOptions() {
            let terms = []
            for(var n = 1; n < 31; n++) {
                terms.push(n)
            }
            return terms
        },
        allLoans() {
            let loans = []
            this.homeLoan.groups.forEach(group => {
                loans = [...loans, ...group.loans]
            })
            return loans
        },
        allProperties() {
            let properties = []
            this.homeLoan.groups.forEach(group => {
                properties = [...properties, ...group.properties]
            })
            return properties
        },
        allOOProperties() {
            return this.allProperties.filter(o => !o.investment)
        },

        summary() {
            return [
                {title: 'New Money', format: 'Currency', value: 0, id:'newMoney', name:'total_new_money', dashboards: true, value: this.totalNewMoney},
                {title: 'Mortgage Insurance', format: 'Currency', value: 0, id:'lmi', name:'total_lmi', value: this.sumLoansWhere('lmi', true, 'lmi')},
                {title: 'Interest Only', format: 'Currency', value: 0, id:'io', name:'total_io', value: this.sumLoansWhere('io', true)},
                {title: 'Fixed Rate', format: 'Currency', value: 0, id:'fixed', name:'total_fixed', value: this.sumLoansWhere('fixed', true)},
                {title: 'Owner Occupied', format: 'Currency', value: 0, id:'ownerOccupied', name:'total_owner_occupied', value: this.sumLoansWhere('investment', false)},
                {title: 'Investment', format: 'Currency', value: 0, id:'investment', name:'total_investment', value: this.sumLoansWhere('investment', true)},
                {title: 'Rate Lock', format: 'Currency', value: 0, id:'rateLock', name:'total_rate_lock', value: this.sumLoansWhere('rateLock', true)},
                {title: 'Special', format: 'Currency', value: 0, id:'special', name:'total_special', value: this.sumLoansWhere('special', true)},
                {title: 'Pro Package', format: 'Currency', value: 0, id:'package', name:'total_package', value: this.sumLoansWhere('package', true)},
                {title: 'Purchase Address', format: 'String', value: this.purchaseAddress, id:'purchase_address', name:'purchase_address'},
                {title: 'Existing Address', format: 'String', value: this.existingAddress, id:'existing_address', name:'existing_address'},
            ] 
        },
        shortSummary() {
                return this.summary.filter(o => o.value).map(o => {
                    return {
                        title: o.title,
                        name: o.name,
                        value: (o.format == 'Currency' ? StringHelpers.formatCurrency(o.value): o.value)
                    }
                })
        },

        purchaseAddress() {
            return StringHelpers.sentenceJoin(
                this.allProperties
                    .filter(property => !property.existing)
                    .map(property => property.address)
            )
        },

        existingAddress() {
            return StringHelpers.sentenceJoin(
                this.allProperties
                    .filter(property => property.existing)
                    .map(property => property.address)
            )
        },

        totalNewMoney() {
            return this.allLoans.reduce( (sum, loan) => {return sum + this.loanNewMoney(loan)},0)
        }
    },

    methods: {

        loanNewMoney(loan) {
            if(loan.newMoney)
                return loan.newMoney
            
            let amt = loan.amount 
            if(loan.lmiType == 'Capitalised' && loan.lmi > 0)
                amt += loan.lmi
            return amt
        },  


        saveDiagram() {
            const result = {
                data: {...this.homeLoan},
                html: this.getHTML(),
                summary: this.summary
            }
            this.$emit('save', result)
        },

        loanTitle(loan) {
            if(!loan.lmiType || loan.lmiType == 'None')
                return NumberHelpers.abbreviateNumber(loan.amount)
            if(loan.lmiType == 'Included')
                return loan.amount + '(incl lmi ' + NumberHelpers.abbreviateNumber(loan.lmi) + ')'
            if(loan.lmiType == 'Capitalised')
                return NumberHelpers.abbreviateNumber(loan.amount + loan.lmi) + ' (' + NumberHelpers.abbreviateNumber(loan.amount) + ' + ' + NumberHelpers.abbreviateNumber(loan.lmi) + ')'
        },

        loanDetails(loan) {
            let desc = (loan.fixed ? 'Fixed ' + loan.fixed + 'y' : 'Vbl') + ', ' + 
                (loan.io ? 'IO ' + loan.io + 'y' : 'P&I')


            if(loan.rate)
                desc = '@ ' + loan.rate + '% ' + desc
            
            if(loan.fixed) {
                if(loan.rateLock)
                    desc += ', Rate Lock'
                else
                    desc += ', No Lock'
            }

            if(loan.product)
                desc += ', ' + loan.product

            if(loan.existing)
                desc += ', *Existing' 
            if(loan.package)
                desc += ', *Package' 
            if(loan.special)
                desc += ', *Special' 

            if(loan.years && loan.years != 30)
                desc += ' over ' + loan.years + 'yrs'

            return desc
        },

        propertyDetails(property) {
            let desc = (property.existing ? 'Existing' : 'New') + ' ' + 
                (property.investment ? 'Investment ' : 'Owner Occ') + ' '
                property.type
            
            if(property.address)
                desc += ' @ ' + property.address

            return desc
        },

        copy() {
                const html = this.getHTML()
                console.log(html)
                clipboard.copy({'text/html': html})
                AlertHelpers.showAlert('Copied')
        },

        getHTML() {
            const html = this.$refs.simple.innerHTML
            return html
        },

        sumLoansWhere(field, exists, fieldToTally = 'amount') {

            let filteredLoans
            if(exists) 
                filteredLoans = this.allLoans.filter(o => o[field])
            else
                filteredLoans = this.allLoans.filter(o => !o[field])

            return filteredLoans.reduce( (sum, val) => {
                return sum + val[fieldToTally]
            }, 0)
        },
     
        countOO() {

        },

        split(loan, duplicate = false) {
            const group = this.getGroup(loan)
            const idx = this.getLoanIndex(loan)
            const newLoan = {...loan}
            if(!duplicate) {
                newLoan.amount = this.nearestFiveThousand(loan.amount / 2)
                loan.amount = loan.amount - newLoan.amount
            }
            group.loans.splice(idx + 1, 0, newLoan)
        },

        addLoan(loan) {
            const group = this.getGroup(loan)
            group.loans.push(this.blankLoan())
        },

        addProperty(property) {
            const group = this.getGroup(property)
            const idx = this.getPropertyIndex(property)
            const newProperty = {value: 400000}

            if(this.allOOProperties.length > 0)
                newProperty.investment = true

            if(this.allProperties.filter(o => o.existing == 0))
                newProperty.existing = true

            group.properties.splice(idx + 1, 0, newProperty)
        },

        deleteLoan(loan) {   
            const group = this.getGroup(loan)
            const idx = this.getLoanIndex(loan)
            if(group.loans.length < 2)
                AlertHelpers.showAlert('Cant delete last loan')
            else
                group.loans.splice(idx,1)
        },
        deleteProperty(property) {
            const group = this.getGroup(property)
            const idx = this.getPropertyIndex(property)
            if(group.properties.length < 2)
                AlertHelpers.showAlert('Cant delete last property')
            else
                group.properties.splice(idx,1)
        },

        async deleteGroup(groupIndex) {
            if(await this.$root.$confirm('Delete Entire Group', 'Are you sure you want to delete group ' + (groupIndex + 1) + '? All loans and properties will be obliterated.', { color: 'red' }) == true) {
                this.homeLoan.groups.splice(groupIndex, 1)
            }
        },

        async help() {
            this.$root.$youTube('2RGsedl2Qr8')
        },

        getLVR(group) {
            const totalLoans = this.totalLoans(group)
            const totalProperties = this.totalProperties(group)
            return Math.round(totalLoans / totalProperties * 10000) / 100
        },

        getGroup(loanOrProperty) {
            let foundGroup = null
            this.homeLoan.groups.forEach(group => {
                
                group.loans.forEach(loan => {
                    if(loan == loanOrProperty) {
                        foundGroup = group
                    }    
                })
                group.properties.forEach(property => {
                    if(property == loanOrProperty)
                        foundGroup = group
                })
            })
            return foundGroup
        },

        getNextLoan(loan) {
            const group = this.getGroup(loan)
            const idx = group.loans.findIndex(o => o == loan)
            return group.loans[idx + 1] || null
        },


        resized(e) {
            console.log (e)
        },

        getPixels(group) {
            const width = this.$el.clientWidth
            const dollars = this.totalProperties(group)

            const pixelsPerDollar = width / dollars

            return pixelsPerDollar * 5000
        },
        getLoanIndex(loan) {
            const group = this.getGroup(loan)
            return group.loans.findIndex(o => o == loan)
        },
        getPropertyIndex(property) {
            const group = this.getGroup(property)
            return group.properties.findIndex(o => o == property)
        },

        loanStyle(loan, propertyGroup) {
            const percent = this.percentage(loan, propertyGroup)
            return `flex-basis:${Math.max(percent, 25)}%;`
        },

        loanBarStyle(loan) {
            const percent = 80 - this.getLoanIndex(loan) * 10
            let col
            if(loan.existing)
                col = '200, 200, 200,'
            else if(loan.investment)
                col = '89, 0, 255,'
            else
                col = '25,156,227,'

            const colString = 'rgba(' + col + percent + '%'
            return {'background-color': colString}
        },

        propertyStyle(property, propertyGroup) {
            const percent = this.percentage(property, propertyGroup)
            const style = `flex-basis:${percent}%;` + this.propertyColour(property, propertyGroup)
            return style
        },


        propertyColour(property, propertyGroup) {
            const backgroundPercent = 90 - this.getPropertyIndex(property) * 10
            let colour =  `background-color:rgba(255, 136, 0,${backgroundPercent}%);`
            if(property.investment)
                colour = `background-color:rgba(255, 81, 0,${backgroundPercent}%);`
            return colour
        },

        percentage(loanOrProperty, propertyGroup) {
            return Math.round(
                (loanOrProperty.amount || loanOrProperty.value) 
                / this.totalProperties(propertyGroup) * 100
            )
        },
        totalLoans(propertyGroup) {
            return propertyGroup.loans.reduce( (acc, val) => {return acc += val.amount}, 0)
        },
        totalProperties(propertyGroup) {
            return propertyGroup.properties.reduce( (acc, val) => {return acc += val.value}, 0)
        },
        groupTitle(groupIndex) {
            return this.homeLoan.groups[groupIndex].title || 'Group ' + (groupIndex + 1).toString()
        },

        checkLockStatus() {
            if(this.homeLoan.locked) {
                AlertHelpers.showAlert('Diagram is locked. Cant change')
                return fale
            }
            return true
        },

        startLoanDrag(e, loan) {

            if(!this.checkLockStatus())
                return
                

            console.log('start drag', e)
           
            const nextLoan = this.getNextLoan(loan)
            if(nextLoan) {
                this.$set(nextLoan, '_dragAmount', nextLoan.amount)
                this.$set(this.homeLoan, '_nextEntity', nextLoan)
            }



            this.$set(loan, '_element', e.currentTarget)
            this.$set(loan, '_dragStart', e.screenX)
            this.$set(loan, '_dragAmount', this.nearestFiveThousand(loan.amount))
            this.$set(this.homeLoan, '_dragEntity', loan)

            // e.currentTarget.firstChild.style.left = e.offsetX -10 + 'px'
            // e.currentTarget.firstChild.style.display = 'block'
            
        },
        startPropertyDrag(e, property) {

            if(!this.checkLockStatus())
                return

            console.log('start prop drag', e)

            this.$set(property, '_element', e.currentTarget)
            this.$set(property, '_dragStart', e.screenX)
            this.$set(property, '_dragAmount', this.nearestFiveThousand(property.value) )
            this.$set(this.homeLoan, '_dragEntity', property)
            e.currentTarget.classList.add('dragging')
        },
        drag(e) {
            const entity = this.homeLoan._dragEntity
            if(entity) {
    
                const totalMouseMovement = e.screenX - entity._dragStart 

                if(Math.abs(totalMouseMovement) > 20)
                    this.dragging = true
                if(!this.dragging)
                    return

                console.log('total movement', totalMouseMovement)
                console.log('xposition:', e.screenX)

                // const handle = entity._element.firstChild
                // handle.style.left = e.offsetX -10 + 'px'
                

                const group = this.getGroup(entity)
                
                const pixels = this.getPixels(group)

                const amountChange = (parseInt(totalMouseMovement / pixels) * 5000)
                     
                // When Loan...
                if(entity.amount) {
                    const nextEntity = this.homeLoan._nextEntity
                    let nextAmount
                    const newAmount = entity._dragAmount + amountChange
                    if(newAmount < 10000)
                        return
                    if(nextEntity) {
                        if(entity._dragMode == 'splitter') {
                            nextAmount = nextEntity._dragAmount - amountChange
                            if(nextAmount < 10000)
                                return
                            nextEntity.amount = nextAmount
                        }
                    }
                    entity.amount = newAmount

                    this.snapLoan(entity)
                }

                // When Property...
                if(entity.value) {
                    const newValue = entity._dragAmount + amountChange
                    if(newValue >= 10000)
                        entity.value = newValue
                }

                    

                
          
            }
        },
        endDrag(e) {
            const entity = this.homeLoan._dragEntity
            if(entity) {

                // const handle = document.getElementsByClassName('floating-handle')[0]
                // handle.style.left = e.screenX + 'px'
                // handle.style.top = e.screenY + 'px'
                // handle.style.display = 'none'

                console.log('stop drag')
                const nextEntity = this.homeLoan._nextEntity
                if(nextEntity) {
                    this.$delete(nextEntity, '_dragAmount')
                    this.$delete(this.homeLoan, '_nextEntity')
                }

                // entity._element.classList.remove('dragging')
                this.$delete(entity, '_dragStart')
                this.$delete(entity, '_dragAmount')
                this.$delete(entity, '_element')
                this.$delete(entity, '_dragMode')
                this.$delete(this.homeLoan, '_dragEntity')
                this.dragging = false
            }
            
        },

        nextThousand(num) {
            return Math.floor( (num + 1000) / 1000) * 1000
        },

        nextFiveThousand(num) {
            
            num = this.nextThousand(num)
            while(num % 5000 > 0) {
                num = num + 1000
            }
            return num
        },

        nearestFiveThousand(num) {
            return Math.round(num / 5000) * 5000
        },

        snapLoan(loan) {
            const commons = [60, 70, 80, 85, 90, 95]
            const group = this.getGroup(loan)
            const otherLoans = this.totalLoans(group) - loan.amount
            const totalProperties = this.totalProperties(group)
            const currentLVR = this.getLVR(group)
            commons.forEach(commonLVR => {
                if(Math.abs(currentLVR - commonLVR) < 1) {
                    loan.amount = totalProperties * commonLVR / 100 - otherLoans
                    return
                }
            })
        },

        editLoan(loan) {
            this.loanDialog.loan = { ...loan, _originalLoan: loan }
            this.loanDialog.settings.visible = true
        },   
        
        saveLoan(loan) {
            const original = loan._originalLoan
            delete loan._originalLoan

            //backfix for nesting....remove later
            delete original._originalLoan

            Utilities.copyProperties(loan, original)
        },

        editProperty(property) {
            this.propertyDialog.property = { ...property, _originalProperty: property }
            this.propertyDialog.settings.visible = true
        },   
        
        saveProperty(property) {
            const original = property._originalProperty
            delete property._originalProperty

            //backfix for nesting....remove later
            delete original._originalProperty
            Utilities.copyProperties(property, original)
        },

        // allowDeleteLoan(loan) {
        //     if(!loan)
        //         return false
        //     const group = this.getGroup(loan)
        //     return group.loans.length > 1
        // },

        // allowDeleteProperty(property) {
        //     if(!property)
        //         return false
        //     const group = this.getGroup(property)
        //     return group.properties.length > 1
        // },

        addGroup() {
            const group = this.blankGroup()
            this.homeLoan.groups.push(group)
        },

        blankGroup() {
            const group = {
                loans: [], properties: []
            }
            group.loans.push(this.blankLoan())
            group.properties.push(this.blankProperty())
            return group
        },

        blankLoan() {
            return {
                amount: 400000,
                rate: 4,
                years: 30,
                investment: false,
                special: false,
                lmi: 0,
                lmiType: 'None',
            }
        }, 

        blankProperty() {
            return {
                value: 500000,
                investment: false,
                existing: false,
                address: '',
            }
        }

    },

    async mounted() {
        if(!this.homeLoan) {
            if(await this.$root.$confirm('New Diagram', 'No loan diagram found. Create one?', { color: 'red' }) == true) {
                const group = this.blankGroup()
                const homeLoan = {groups:[group]}
                this.$emit('change', homeLoan)
            }
        }   
    },

    watch: {
        homeLoan: {
            handler: function(newVal, oldVal) {
                // console.log('Something Changed', oldVal, newVal)
            },
            deep: true,
        }
    }

}
</script>

<style scoped>

.simple-version-div {
    /* visibility: hidden;  */
    height:0px; overflow: hidden;
}

.bottom-links {
    padding:5px;
    font-size: 14px;
}

.loan {
    opacity:.9
}
.loan:hover {
    opacity: 1;
}
.loan-handle {
    border-radius:15px;
    height:100%;width:30px;
    min-height:30px;min-width:30px;
    margin-right:-15px;
    margin-left:-15px;
    box-shadow: 0px 0px 0px 0px transparent;
    transition: box-shadow .4s ease-in-out;
    z-index: 200;
}
.loan-handle.dragging {

    background-color: rgba(25,156,227,0.4);
    box-shadow: 0px 0px 0px 10px rgba(25,156,227,0.24);
    cursor: col-resize;
}
.loan.dragging {
    background-color: rgba(25,156,227,0.4);
    box-shadow: 0px 0px 0px 10px rgba(25,156,227,0.24);
    cursor: ew-resize;
}

.property.dragging {
    background-color: rgba(25,156,227,0.4);
    box-shadow: 0px 0px 0px 10px rgba(25,156,227,0.24);
    cursor: ew-resize;
}

.property {
    opacity: .9;
}
.property:hover {
    opacity: 1;
}

.drag-button {

}

.dragging .drag-button {
    background-color:rgba(255, 136, 0, 0.671);
}

.floating-handle {
    position:absolute;
    background-color:rgba(89, 0, 255, 0.747);
    width: 30px; height: 30px;
    left:0px; top:4px;
    border-radius: 999px;
    /* display:none; */

}

.summary > div {
    display: inline-block;
    border: solid 1px #ccc;
    border-radius: 999px;
    font-size: 12px;
    color: #777;
    padding:3px 8px;
    margin:2px;
    transition: opacity .5s ease-in-out;
}

.summary.hidden {
    height:0px;
    opacity: 0;
}

/* .summary > div::after {
    content: ' |'
} */


   
</style>




// WEBPACK FOOTER //
// HomeLoan.vue?571c0558